import React, { ReactElement, ReactNode } from 'react'
import { Flex, Text, ThemeUIStyleObject } from 'theme-ui'
import { Button, Svg } from 'ui'
import LinkedInIcon from 'images/organization/features/malware/linkedin-icon.svg'

export default function ExpertItem({
  image,
  title,
  comment,
  expertName,
  expertPosition,
  expertPositionAndName,
  sx,
  linkedInUrl,
}: {
  image: ReactNode
  title: string
  comment: string
  expertName?: string
  expertPosition?: string | ReactNode
  expertPositionAndName?: ReactNode
  sx?: ThemeUIStyleObject
  linkedInUrl: string
}): ReactElement {
  return (
    <Flex
      sx={{
        width: ['100%', '36rem'],
        height: ['fit-content', '45.5rem'],
        position: 'relative',
        borderRadius: '1.2rem',
        border: '1px solid',
        borderColor: 'blueYonder20',
        backgroundColor: 'blue800',
        px: ['1.6rem', '3.2rem'],
        pt: '8rem',
        pb: ['2.4rem', '4.4rem'],
        justifyContent: 'center',
        ...sx,
      }}
    >
      <Flex
        sx={{
          position: 'absolute',
          top: '-6rem',
          width: '10rem',
          height: '10rem',
          borderRadius: '50%',
          overflow: 'hidden',
        }}
      >
        {image}
      </Flex>
      <Flex
        sx={{
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: '1.4rem',
        }}
      >
        <Flex
          sx={{
            flexDirection: 'column',
            gap: '1.4rem',
          }}
        >
          <Text variant="size17Weight600Line138" sx={{ color: 'aliceBlue' }}>
            {title}
          </Text>
          <Text variant="size16Weight400Line140" sx={{ color: 'wildBlueYonder' }}>
            {comment}
          </Text>
        </Flex>
        <Flex sx={{ flexDirection: 'column', gap: '0.8rem' }}>
          {expertName && (
            <Text variant="size16Weight600Line138" sx={{ color: 'aliceBlue' }}>
              {expertName}
            </Text>
          )}
          <Flex
            sx={{
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            {expertPosition && (
              <Text
                variant="size13Weight300Line138"
                sx={{
                  color: 'wildBlueYonder70',
                }}
              >
                {expertPosition}
              </Text>
            )}
            {expertPositionAndName}
            <Button
              ariaLabel={`go to ${linkedInUrl}`}
              variant="simple"
              sx={{ p: '1.2rem', borderRadius: '0.8rem', backgroundColor: 'blueYonder20' }}
              onClick={() => {
                window.open(linkedInUrl, '_blank', 'noopener, noreferrer')
              }}
            >
              <Svg
                svg={LinkedInIcon}
                sx={{ height: '1.6rem', width: '1.6rem', opacity: '0.25' }}
                descriptiveText={`LinkedIn profile link for ${expertName}`}
              />
            </Button>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )
}
